import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/enquiries`;

export const submitEnquiry = (kind, payload) => axios.post(`${API}/${kind}`, payload);

export const enquiryError = (err) => {
  const status = err?.response?.status;
  if (status === 429) return 'Too many submissions. Please try again in a few minutes.';
  if (status === 422) {
    const field = err.response.data?.detail?.[0]?.loc?.slice(-1)[0];
    const messages = {
      email: 'Please enter a valid email address.',
      phone: 'Please enter a valid phone number.',
      name: 'Please enter your name.',
      city: 'Please enter your city.',
    };
    return messages[field] || 'Please check your details and try again.';
  }
  return 'Something went wrong. Please try again or email hello@tropicblue.in.';
};
